export const provinces_data = {
  data: [
    {
      province: "اردبيل",
      id: "24",
    },
    {
      province: "اصفهان",
      id: "10",
    },
    {
      province: "البرز",
      id: "30",
    },
    {
      province: "ايلام",
      id: "16",
    },
    {
      province: "آذربايجان شرقی",
      id: "03",
    },
    {
      province: "آذربايجان غربی",
      id: "04",
    },
    {
      province: "بوشهر",
      id: "18",
    },
    {
      province: "تهران",
      id: "23",
    },
    {
      province: "چهارمحال وبختياری",
      id: "14",
    },
    {
      province: "خراسان جنوبی",
      id: "29",
    },
    {
      province: "خراسان رضوی",
      id: "09",
    },
    {
      province: "خراسان شمالی",
      id: "28",
    },
    {
      province: "خوزستان",
      id: "06",
    },
    {
      province: "زنجان",
      id: "19",
    },
    {
      province: "سمنان",
      id: "20",
    },
    {
      province: "سيستان وبلوچستان",
      id: "11",
    },
    {
      province: "فارس",
      id: "07",
    },
    {
      province: "قزوين",
      id: "26",
    },
    {
      province: "قم",
      id: "25",
    },
    {
      province: "كردستان",
      id: "12",
    },
    {
      province: "كرمان",
      id: "08",
    },
    {
      province: "كهگيلويه وبويراحمد",
      id: "17",
    },
    {
      province: "کرمانشاه",
      id: "05",
    },
    {
      province: "گلستان",
      id: "27",
    },
    {
      province: "گيلان",
      id: "01",
    },
    {
      province: "لرستان",
      id: "15",
    },
    {
      province: "مازندران",
      id: "02",
    },
    {
      province: "مرکزی",
      id: "00",
    },
    {
      province: "هرمزگان",
      id: "22",
    },
    {
      province: "همدان",
      id: "13",
    },
    {
      province: "يزد",
      id: "21",
    },
  ],
};
